(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hema-shoppable-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hema-shoppable-videos')) {
    customElements.define(
      'hema-shoppable-videos',
      class HemaShoppableVideos extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.hsv__track');
          this.prev = this.querySelector('.hsv__arrow--prev');
          this.next = this.querySelector('.hsv__arrow--next');
          this.medias = Array.from(this.querySelectorAll('.hsv__media'));

          this.medias.forEach((media) => {
            const video = media.querySelector('video');
            if (!video) return;
            video.addEventListener('play', () => media.classList.add('is-playing'));
            video.addEventListener('pause', () => media.classList.remove('is-playing'));

            media.addEventListener('click', (event) => {
              const muteButton = event.target.closest('.hsv__mute');
              if (muteButton) {
                this.setSound(video, video.muted);
                return;
              }
              if (video.paused) {
                video.dataset.userPaused = '';
                video.play().catch(() => {});
              } else {
                video.dataset.userPaused = 'true';
                video.pause();
              }
            });
          });

          if (this.prev) this.prev.addEventListener('click', () => this.slide(-1));
          if (this.next) this.next.addEventListener('click', () => this.slide(1));
          if (this.track) this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          this.updateArrows();

          if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  const video = entry.target.querySelector('video');
                  if (!video) return;
                  if (entry.isIntersecting) {
                    if (video.dataset.userPaused !== 'true') video.play().catch(() => {});
                  } else {
                    video.pause();
                  }
                });
              },
              { threshold: 0.6 }
            );
            this.medias.forEach((media) => this.observer.observe(media));
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        setSound(video, soundOn) {
          this.medias.forEach((media) => {
            const other = media.querySelector('video');
            const button = media.querySelector('.hsv__mute');
            const on = other === video && soundOn;
            if (other) other.muted = !on;
            if (button) button.classList.toggle('is-unmuted', on);
          });
          if (soundOn && video.paused) video.play().catch(() => {});
        }

        slide(direction) {
          const card = this.track && this.track.querySelector('.hsv__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        }

        updateArrows() {
          if (!this.track) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
